<template>
    <!-- CONFIGURATION ERROR DIALOG -->
            <v-dialog
                    v-model="shown"
                    max-width="600"
                    :persistent="is_persistent"
                    >
                    <v-alert
      colored-border
      border="bottom"
      type="error"
      class="ma-0"
      elevation="2"
    >
    <v-row>
         <h3 style="margin-bottom: 10px;">{{title}}</h3>
            <p style="padding-right: 20px;">
                <slot>Something went wrong in the app... please contact admin</slot>
            </p>
              <span style="color:#999;" v-if="code !== null"><b><i>
                {{$vuetify.lang.t('$vuetify.global.code')}} <span style="color:#000;">{{code}}</span>
                       </i></b>
               </span>
    </v-row>
    <v-row v-if="is_cancelable">
        <v-spacer></v-spacer>
        <v-btn
            text @click.prevent="close" >
            {{buttonText}}
          </v-btn>
    </v-row>
          
                </v-alert>
            </v-dialog>
            <!-- END CONFIGURATION ERROR DIALOG -->
</template>
<script>
export default {
    props : {
        shown : {
            type: Boolean,
            required : true
        },
        is_persistent:{
            type: Boolean,
            default : true
        },
         title : {
            type: String,
            required : true
        },
         code : {
            type: String,
        },
        is_cancelable:{
            type: Boolean,
            default : false
        },
       closeBtnText: {
          type : String,
          default : ''
       },
       interceptsClose: {
          type: Boolean,
          default : false
       }
    },
    methods : {
        close (){
           if(this.interceptsClose){
             this.$emit('closeClicked', true)
           }else{
             this.$router.replace('/');
           }

        } 
    },
    computed : {
      buttonText(){
        return (this.closeBtnText.length <= 0)? this.$vuetify.lang.t('$vuetify.global.close') : this.closeBtnText
      }
    }
}
</script>